/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { Owner } from "../../../models/owner.model"
import { Property } from "../../../models/property.model"
import { Unit } from "../../../models/unit.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { PROPERTY_ENDPOINT } from "../property.endpoint"

let propertyCollection: CollectionQuery
let propertyCountCollection: CollectionQuery
let unitCollection: CollectionQuery
let unitCountCollection: CollectionQuery
let ownersOfPropertyCollection: CollectionQuery
let archivedPropertyCollection: CollectionQuery
let propertiesOfUnitCollection: CollectionQuery

const propertyQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getProperty: builder.query<
      Property,
      { id: string; query: CollectionQuery }
    >({
      query: (data: { id: string; query: CollectionQuery }) => ({
        url: `${PROPERTY_ENDPOINT.detail}/${data.id}`,
        method: "get",
        params: collectionQueryBuilder(data.query),
      }),
      providesTags: ["Property"],
    }),

    getProperties: builder.query<Collection<Property>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PROPERTY_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Properties"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   propertyCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countProperties: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PROPERTY_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Properties"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   propertyCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    getUnitsOfProperty: builder.query<Collection<Unit>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PROPERTY_ENDPOINT.getUnits}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Unit of Properties"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   unitCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countUnitsOfProperty: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PROPERTY_ENDPOINT.getUnits}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Unit of Properties"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   unitCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getOwnersOfProperty: builder.query<Collection<Owner>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PROPERTY_ENDPOINT.getOwnersOfProperty}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            ownersOfPropertyCollection = param
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getPropertiesOfUnit: builder.query<Collection<Property>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PROPERTY_ENDPOINT.getPropertiesForUnit}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            propertiesOfUnitCollection = param
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getArchivedProperty: builder.query<Property, string>({
      query: (id: string) => ({
        url: `${PROPERTY_ENDPOINT.archivedProperty}/${id}`,
        method: "get",
      }),
    }),

    getArchivedProperties: builder.query<Collection<Property>, CollectionQuery>(
      {
        query: (data: CollectionQuery) => ({
          url: `${PROPERTY_ENDPOINT.archivedProperties}`,
          method: "GET",
          params: collectionQueryBuilder(data),
        }),
        async onQueryStarted(param, { queryFulfilled }) {
          try {
            const { data } = await queryFulfilled
            if (data) {
              archivedPropertyCollection = param
            }
          } catch (error: any) {
            notification(
              "error",
              error?.error?.data?.message
                ? error?.error?.data?.message
                : "Error try again",
            )
          }
        },
      },
    ),

    createProperty: builder.mutation<Property, Property>({
      query: (newData: any) => ({
        url: `${PROPERTY_ENDPOINT.create}`,
        method: "post",
        data: newData,
        permissions: "manage-properties",
      }),
      invalidatesTags: ["Properties", "Property", "Count Properties"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperties",
            //     propertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.push(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateProperty: builder.mutation<Property, Property>({
      query: (newData: any) => ({
        url: `${PROPERTY_ENDPOINT.update}`,
        method: "put",
        data: newData,
        permission: "manage-properties",
      }),
      invalidatesTags: ["Properties", "Property", "Count Properties"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperties",
            //     propertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((property) => {
            //           if (property.id === data.id) return data
            //           else {
            //             return property
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    togglePropertyStatus: builder.mutation<Property, string>({
      query: (id: string) => ({
        url: `${PROPERTY_ENDPOINT.toggleStatus}/${id}`,
        method: "post",
        permission: "manage-properties",
      }),
      invalidatesTags: ["Properties", "Property", "Count Properties"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperties",
            //     propertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((property: Property) => {
            //           if (property.id === data.id) return data
            //           else {
            //             return property
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperty",
            //     param,
            //     (draft) => {
            //       draft.enabled = data.enabled
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    bulkTogglePropertyStatus: builder.mutation<
      boolean,
      { ids: string[]; enabled: boolean }
    >({
      query: (data: { ids: string[]; enabled: boolean }) => ({
        url: `${PROPERTY_ENDPOINT.bulkToggleStatus}`,
        method: "post",
        permission: "manage-properties",
        data: data,
      }),
      invalidatesTags: ["Properties", "Property", "Count Properties"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperties",
            //     propertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((property: Property) => {
            //           if (property.id === data.id) return data
            //           else {
            //             return property
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperty",
            //     param,
            //     (draft) => {
            //       draft.enabled = data.enabled
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    archiveProperty: builder.mutation<Property, { id: string; reason: string }>(
      {
        query: (data) => ({
          url: `${PROPERTY_ENDPOINT.archive}`,
          method: "delete",
          data: data,
          permission: "manage-properties",
        }),
        invalidatesTags: ["Properties", "Property", "Count Properties"],

        async onQueryStarted(arg, { dispatch, queryFulfilled }) {
          try {
            const { data } = await queryFulfilled
            if (data) {
              // dispatch(
              //   propertyQuery.util.updateQueryData(
              //     "getProperties",
              //     propertyCollection,
              //     (draft) => {
              //       draft.data = draft?.data?.map((provider) => {
              //         if (provider.id === arg.id) {
              //           return data
              //         } else {
              //           return provider
              //         }
              //       })
              //     },
              //   ),
              // )
              // dispatch(
              //   propertyQuery.util.updateQueryData(
              //     "getProperty",
              //     arg?.id,
              //     (draft) => {
              //       draft.deletedAt = data?.deletedAt
              //     },
              //   ),
              // )
              // dispatch(
              //   propertyQuery.util.updateQueryData(
              //     "getArchivedProperty",
              //     arg?.id,
              //     (draft) => {
              //       draft.deletedAt = data?.deletedAt
              //     },
              //   ),
              // )
              notification("success", "Successfully archived")
            }
          } catch (error: any) {
            notification(
              "error",
              error?.error?.data?.message ?? "Error try again",
            )
          }
        },
      },
    ),

    deleteProperty: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${PROPERTY_ENDPOINT.delete}/${id}`,
        method: "delete",
        permission: "manage-properties",
      }),
      invalidatesTags: ["Properties", "Property", "Count Properties"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getArchivedProperties",
            //     archivedPropertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter(
            //           (property) => property.id !== id,
            //         )
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    restoreProperty: builder.mutation<Property, string>({
      query: (id: string) => ({
        url: `${PROPERTY_ENDPOINT.restore}/${id}`,
        method: "post",
        permission: "manage-properties",
      }),
      invalidatesTags: ["Properties", "Property", "Count Properties"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperties",
            //     propertyCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((provider) => {
            //         if (provider.id === id) {
            //           return data
            //         } else {
            //           return provider
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData("getProperty", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getArchivedProperty",
            //     id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully restored")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    addUnit: builder.mutation<Unit, Unit>({
      query: (newData: any) => ({
        url: `${PROPERTY_ENDPOINT.addUnit}`,
        method: "post",
        data: newData,
        permissions: "manage-units",
      }),
      invalidatesTags: ["Unit of Properties", "Count Unit of Properties"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperty",
            //     data.id as string,
            //     (draft) => {
            //       Object.assign(draft, data)
            //     },
            //   ),
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getUnitsOfProperty",
            //     unitCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.push(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperties",
            //     propertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft?.data?.map((property: Property) =>
            //           property.id == data?.propertyId
            //             ? property?.units?.unshift(data)
            //             : "",
            //         )
            //         // draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    updateUnit: builder.mutation<Property, Unit>({
      query: (newData: any) => ({
        url: `${PROPERTY_ENDPOINT.updateUnit}`,
        method: "post",
        data: newData,
        permissions: "manage-units",
      }),
      invalidatesTags: ["Unit of Properties", "Count Unit of Properties"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully Updated")
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     'getProperty',
            //     data.id as string,
            //     (draft) => {
            //       Object.assign(draft, data);
            //     }

            //   )
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getUnitsOfProperty",
            //     unitCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.filter((unit: Unit) => {
            //           if (unit.id == data.id) return data
            //           else return unit
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    toggleUnitStatus: builder.mutation<Unit, string>({
      query: (id: string) => ({
        url: `${PROPERTY_ENDPOINT.toggleUnitStatus}/${id}`,
        method: "post",
        permission: "manage-properties",
      }),
      invalidatesTags: ["Unit of Properties"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperties",
            //     propertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((property: Property) => {
            //           if (property.id === data.id) return data
            //           else {
            //             return property
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperty",
            //     param,
            //     (draft) => {
            //       draft.enabled = data.enabled
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    bulkToggleUnitStatus: builder.mutation<
      boolean,
      { ids: string[]; enabled: boolean }
    >({
      query: (data: { ids: string[]; enabled: boolean }) => ({
        url: `${PROPERTY_ENDPOINT.bulkToggleUnitStatus}`,
        method: "post",
        permission: "manage-properties",
        data: data,
      }),
      invalidatesTags: ["Unit of Properties"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperties",
            //     propertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((property: Property) => {
            //           if (property.id === data.id) return data
            //           else {
            //             return property
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperty",
            //     param,
            //     (draft) => {
            //       draft.enabled = data.enabled
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    removeUnit: builder.mutation<Property, string>({
      query: (id: string) => ({
        url: `${PROPERTY_ENDPOINT.removeUnit}`,
        method: "delete",
        data: {
          id: id,
        },
        permission: "manage-units",
      }),
      invalidatesTags: ["Unit of Properties", "Count Unit of Properties"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")

            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperties",
            //     propertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter((property: Property) => {
            //           return property.id !== data.id
            //         })
            //       }
            //     },
            //   ),
            // )

            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getProperty",
            //     data.id as string,
            //     (draft) => {
            //       Object.assign(draft, data)
            //     },
            //   ),
            // )
            // dispatch(
            //   propertyQuery.util.updateQueryData(
            //     "getArchivedProperties",
            //     archivedPropertyCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter(
            //           (property) => property.id !== id,
            //         )
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
  }),
  overrideExisting: true,
})
export const {
  useLazyGetArchivedPropertiesQuery,
  useLazyGetArchivedPropertyQuery,
  useLazyGetPropertiesQuery,
  useLazyCountPropertiesQuery,
  useLazyCountUnitsOfPropertyQuery,
  useLazyGetPropertyQuery,
  useLazyGetUnitsOfPropertyQuery,
  useLazyGetOwnersOfPropertyQuery,
  useLazyGetPropertiesOfUnitQuery,
  useUpdatePropertyMutation,
  useCreatePropertyMutation,
  useDeletePropertyMutation,
  useArchivePropertyMutation,
  useRestorePropertyMutation,
  useTogglePropertyStatusMutation,
  useAddUnitMutation,
  useRemoveUnitMutation,
  useUpdateUnitMutation,
  useToggleUnitStatusMutation,
  useBulkTogglePropertyStatusMutation,
  useBulkToggleUnitStatusMutation,
} = propertyQuery
